import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import api, { authStore } from "@/lib/api";

export default function Register() {
    const [form, setForm] = useState({ full_name: "", email: "", password: "" });
    const [loading, setLoading] = useState(false);
    const nav = useNavigate();

    const submit = async (e) => {
        e.preventDefault();
        setLoading(true);
        try {
            const { data } = await api.post("/auth/register", form);
            authStore.setSession(data.token, data.user);
            toast.success("Account created");
            nav("/");
        } catch (err) {
            toast.error(err?.response?.data?.detail || "Registration failed");
        }
        setLoading(false);
    };

    return (
        <main data-testid="register-page" className="pt-[72px] min-h-screen bg-[#0B1930] text-white flex items-center justify-center">
            <form onSubmit={submit} className="w-full max-w-md bg-white text-navy rounded-2xl p-8">
                <div className="eyebrow eyebrow--slate">Create Account</div>
                <h1 className="font-serif text-3xl mt-3">Get started.</h1>
                <div className="mt-6 space-y-4">
                    <input data-testid="register-name" required placeholder="Full name" value={form.full_name} onChange={(e) => setForm({ ...form, full_name: e.target.value })} className="w-full border border-slate-200 rounded-md px-4 py-3" />
                    <input data-testid="register-email" required type="email" placeholder="Work email" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} className="w-full border border-slate-200 rounded-md px-4 py-3" />
                    <input data-testid="register-password" required type="password" placeholder="Password (min 8 chars)" value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })} className="w-full border border-slate-200 rounded-md px-4 py-3" />
                    <button data-testid="register-submit" disabled={loading} className="btn-primary w-full justify-center">{loading ? "Creating…" : "Create account"}</button>
                    <p className="text-center text-sm text-slate-500">Already have an account? <Link to="/login" className="text-navy underline">Sign in</Link></p>
                </div>
            </form>
        </main>
    );
}
